import { Component } from '@angular/core';

@Component({
  selector: 'app-ux',
  template: `<app-audit-category sectionKey="ux"></app-audit-category>`,
})
export class UxComponent {}
